import React from 'react';
import styles from './style/LinkButton.module.scss';

type PrivateProps = {
  id: string
  title?: string | JSX.Element;
  tooltip?: string;
  disable?: boolean;
  smallHide?: boolean;
  buttonColor?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

export default function LinkButton({
  id,
  children,
  title,
  tooltip,
  smallHide,
  buttonColor,
  disable = false,
  onClick,
}: PrivateProps) {
  return (
    <div className={`${styles.linkButtonContainer} ${styles.tooltip}`}>
      <button
        id={id}
        onClick={() => !disable && onClick && onClick()}
        className={`
            ${styles.linkButton}
            ${disable ? styles.disabled : ''}
            ${title ? styles.title : ''}
            ${buttonColor ? styles[buttonColor] : ''}
            `}
      >
        {children && children}
        {title && (
          <p className={`${smallHide ? styles.smallHide : ''}`}>{title}</p>
        )}
      </button>
      {tooltip && (
        <div className={styles.textContainer}>
          {/* <h3>{tooltip}</h3> */}
          <p>{tooltip}</p>
          <i></i>
        </div>
      )}
    </div>
  );
}
